import { schema } from 'normalizr';

export const labelReviewInciSchema = new schema.Entity('labelReviewIncis', {}, { idAttribute: 'LabelReviewInciId' });

